// Google Analytics 4 Utility
// Only loads if REACT_APP_GA_MEASUREMENT_ID is set

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize GA4
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.log('GA4: No measurement ID configured');
    return;
  }

  // Prevent duplicate initialization
  if (window.gaInitialized) return;
  window.gaInitialized = true;

  try {
    // Load gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, {
      send_page_view: false // We'll send manually for SPA
    });

    console.log('GA4: Initialized with ID', GA_MEASUREMENT_ID);
  } catch (error) {
    console.error('GA4: Failed to initialize', error);
  }
};

// Track page view
export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  try {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: document.title
    });
  } catch (e) {
    console.error('GA4: Page view tracking failed', e);
  }
};

// Track custom events
export const trackEvent = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID || !window.gtag) return;
  try {
    window.gtag('event', eventName, params);
  } catch (e) {
    console.error('GA4: Event tracking failed', e);
  }
};

// Predefined event trackers
export const analytics = {
  signupSuccess: (email) => trackEvent('signup_success', { method: 'email' }),
  loginSuccess: (email) => trackEvent('login_success', { method: 'email' }),
  pdfUpload: (fileName) => trackEvent('pdf_upload', { file_name: fileName }),
  quizGenerated: (sessionId) => trackEvent('quiz_generated', { session_id: sessionId }),
  examGenerated: (sessionId) => trackEvent('exam_generated', { session_id: sessionId }),
  flashcardsGenerated: (sessionId) => trackEvent('flashcards_generated', { session_id: sessionId }),
  explanationGenerated: (sessionId) => trackEvent('explanation_generated', { session_id: sessionId }),
  upgradeButtonClicked: (location) => trackEvent('upgrade_button_clicked', { location }),
  checkoutSuccess: (sessionId) => trackEvent('checkout_success', { session_id: sessionId }),
  feedbackSubmitted: (type) => trackEvent('feedback_submitted', { feedback_type: type })
};

export default analytics;
